import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import responsiblesService from "presentation/services/responsibles";
import usersService from "presentation/services/users";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import ResponsibleUserForm from 'presentation/pages/responsibles/elements/responsible-user-form';

import { handleChange } from "presentation/utils/functions/generic";

class ResponsibleUserInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.loadData(id);
  }

  loadData = async (id) => {
    await responsiblesService.findById(id).then(async (result) => {
      var responsibleInfo = {
        id: result.id,
        registration: result.registration
      }

      if (typeof (result.person) !== 'undefined') {


        responsibleInfo = {
          ...responsibleInfo,
          personId: result.person.id,
          userId: result.person.userId,
          name: result.person.name,
          displayName: result.person.displayName,
          documentField: result.person.documentField
        }
        if (result.person.userId) {
          await usersService.findById(result.person.userId).then((userResult) => {
            responsibleInfo.email = userResult.email;
            responsibleInfo.username = userResult.username;
          });
        }

      }
      this.setState({ form: responsibleInfo, loading: false });
    });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {
    const { id, dependentId, studentId } = this.props.match.params;
    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      email,
      newPassword,
      userId
    } = this.state.form;

    if (!email) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um email válido..." });
    } else {
      if (!userId && !newPassword) {
        this.setState({ loading: false, error: true, message: "Por favor, preencha uma senha..." });
      } else {
        let postData = this.state.form;
        postData.password = postData.newPassword;

        try {
          const response = await responsiblesService.saveUser(postData);
          if (response.error == true) {
            this.setState({
              loading: false,
              actionLoading: false,
              error: true,
              message: response.message
            });
          } else {

            this.goTo(`/responsaveis/${dependentId}/${studentId}`);
          }
        } catch (err) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: err.message
          });
        }
      }

    }
  };

  render() {
    let { location } = this.props;
    const { dependentId, studentId, id } = this.props.match.params;
    let { loading, error, message, actionLoading, form } = this.state;
    let { handleSubmit } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <ResponsibleUserForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                form={form}
                responsibleId={id}
                dependentId={dependentId}
                studentId={studentId}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default ResponsibleUserInfo;
